<template>
  <div class="join">
    <span class="title1">合作伙伴</span>
    <div class="img1">
      <img src="../assets/images/partner1.png" />
      <img src="../assets/images/partner2.png" />
      <img src="../assets/images/partner3.png" />
      <img src="../assets/images/partner4.png" />
      <img src="../assets/images/partner5.png" />
      <img src="../assets/images/partner6.png" />
      <img src="../assets/images/partner7.png" />
      <img src="../assets/images/partner8.png" />
      <img src="../assets/images/partner9.png" />
      <div class="more">
        <!-- 更多 >> -->
        <!-- <router-link to="/about">更 多 >></router-link> -->
        <p @click="toURL('/about', 'joins')">更 多 >></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    toURL(path, id) {
      var path = path;
      var Id = id;
      localStorage.setItem("toId", Id);
      this.$router.push(path);
    }
  }
};
</script>

<style scoped>
.join {
  margin-top: 100px;
}
.title1 {
  color: #333333;
  font-size: 30px;
  font-weight: bold;
}
.img1 {
  width: 1480px;
  margin-top: 74px;
  margin-left: 283px;
  text-align: left;
}
.img1 img {
  width: 315px;
  height: 131px;
  margin-top: 50px;
  margin-left: 16px;
}
.more {
  display: inline-block;
  background-color: rgb(239, 161, 31);
  width: 315px;
  height: 131px;
  margin-left: 16px;
  position: relative;
}
.more p {
  position: absolute;
  top: 50px;
  left: 110px;
  font-size: 22px;
  color: #fff;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Friends.vue